let retriesRemaining = 10;

const enhanceBssRegistrationForm = () => {
  const renderedForm = document.querySelector("#bss-b2b-registration-form-render");

  if (!renderedForm) {
    if (retriesRemaining-- > 0) window.setTimeout(enhanceBssRegistrationForm, 300);
    return;
  }

  const passwordField = document.querySelector(".form-control.password-field");
  if (passwordField) passwordField.insertAdjacentElement("afterend", renderedForm);

  document.querySelectorAll(
    '#create_customer .rendered-form input:not([type="checkbox"]):not([type="file"]):not(.country-field):not([type="hidden"]):not([type="submit"])'
  ).forEach((input) => {
    input.setAttribute("placeholder", " ");

    const parent = input.parentElement;
    const label = parent?.querySelector("label") || parent?.parentElement?.querySelector("label");

    if (parent) parent.style.position = "relative";
    if (label) input.insertAdjacentElement("afterend", label);
  });
};

enhanceBssRegistrationForm();

if (window.BSS_B2B && window.location.pathname.includes("/account/register")) {
  window.setTimeout(() => {
    const stateField = document.querySelector("#create_customer .field-state-field");
    if (!stateField) return;

    stateField.classList.add("form-control");

    const select = stateField.querySelector("select");
    const label = stateField.querySelector("label");

    if (select && label) {
      select.classList.add("input", "is-floating");
      label.classList.add("floating-label");
      select.insertAdjacentElement("afterend", label);
    }
  }, 300);
}
